// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 184) return "static/chunks/184-e60fe9fe82f485b4.js";
	if (chunkId === 36) return "static/chunks/36-ebcbec1d10f0f66e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6174":"35ac7fdfc749af3c","6688":"e27fdb68af0099f9"}[chunkId] + ".js";
};